// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/@umijs+react-refresh-webpack-plugin@0.5.11_@types+webpack@5.28.5_react-refresh@0.14.0_type-fest@1.4.0_webpack@5.102.0/node_modules/@umijs/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/.pnpm/@umijs+bundler-webpack@4.3.35_@types+webpack@5.28.5_type-fest@1.4.0_typescript@5.9.3_webpack@5.102.0/node_modules/@umijs/bundler-webpack/client/client/client.js");
var __webpack_exports__ = __webpack_require__("./src/.umi/umi.ts");
